/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submitted_TitleInputs */

const en_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Submitted Successfully`)
};

const fr_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tache soumise avec succes`)
};

const de_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auftrag erfolgreich übermittelt`)
};

const it_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro inviato con successo`)
};

const ru_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявка успешно отправлена.`)
};

const es_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo enviado exitosamente`)
};

const zh_cn2_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`职位提交成功`)
};

const ja_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブが正常に送信されました`)
};

const hi_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य सफलतापूर्वक सबमिट हो गया`)
};

const pt_pt2_embed_captions_submitted_title = /** @type {(inputs: Embed_Captions_Submitted_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho submetido com sucesso.`)
};

/**
* | output |
* | --- |
* | "Job Submitted Successfully" |
*
* @param {Embed_Captions_Submitted_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_title = /** @type {((inputs?: Embed_Captions_Submitted_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_submitted_title(inputs)
	if (locale === "de") return de_embed_captions_submitted_title(inputs)
	if (locale === "it") return it_embed_captions_submitted_title(inputs)
	if (locale === "ru") return ru_embed_captions_submitted_title(inputs)
	if (locale === "es") return es_embed_captions_submitted_title(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_submitted_title(inputs)
	if (locale === "ja") return ja_embed_captions_submitted_title(inputs)
	if (locale === "hi") return hi_embed_captions_submitted_title(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_submitted_title(inputs)
	return en_embed_captions_submitted_title(inputs)
});